import React from 'react';
import { Box, useTheme } from '@mui/material';

const ICON_DARK = '/static/assets/infralytiqs/infralytiqs-dark.svg';
const ICON_LIGHT = '/static/assets/infralytiqs/infralytiqs-light.svg';

/** Theme-aware Infralytiqs brand mark for the sidebar accordion header. */
export const InfralytiqsSidebarIcon: React.FC = () => {
  const theme = useTheme();
  const src = theme.palette.mode === 'dark' ? ICON_DARK : ICON_LIGHT;

  return (
    <Box
      component="img"
      src={src}
      alt=""
      aria-hidden
      sx={{
        width: 28,
        height: 28,
        display: 'block',
        objectFit: 'contain',
        flexShrink: 0,
      }}
    />
  );
};

export default InfralytiqsSidebarIcon;
